import { AppState } from '../types';
import { HomeScreenState } from './slice';

export const homeScreenStateSelector = (state: AppState): HomeScreenState => state.homescreen;
